// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WjGb","question":"styles_question__rIpPc","description":"styles_description__1DeGd"};